import {
  DateRangeSetting,
  PatientState,
  PatientStatus,
  SexType,
} from '@lmt/shared-types';
import {
  createEnumArrayParam,
  createNumericArrayParam,
} from '@lmt/unicorn-shared/app/helpers/use-query-params-in-tab';
import { JsonParam } from 'serialize-query-params';
import { BooleanParam, StringParam } from 'react-router-url-params';
import { QueryParamConfig } from 'serialize-query-params';

const DateRangeSettingParam: QueryParamConfig<
  DateRangeSetting | null | undefined,
  DateRangeSetting | null | undefined
> = {
  encode: JsonParam.encode,
  decode: (value: string | (string | null)[] | null | undefined) => {
    const result = JsonParam.decode(value) as
      | DateRangeSetting
      | null
      | undefined;
    if (!result) return result;

    result.absoluteMoment = new Date(result.absoluteMoment!);
    return result;
  },
};

export const patientListParams = {
  isFilterDisplayed: BooleanParam,
  hasFilterBySubtenants: BooleanParam,
  hasFilterByTags: BooleanParam,
  hasFilterBySexTypes: BooleanParam,
  hasFilterByStatuses: BooleanParam,
  hasFilterByStates: BooleanParam,
  hasFilterByLastActivity: BooleanParam,
  hasFilterByLastVisit: BooleanParam,
  hasFilterBySqlFilter: BooleanParam,
  subtenants: createNumericArrayParam({ ifNotPresent: 'emptyArray' }),
  tags: createNumericArrayParam({ ifNotPresent: 'emptyArray' }),
  sexTypes: createEnumArrayParam<SexType>({ ifNotPresent: 'emptyArray' }),
  statuses: createEnumArrayParam<PatientStatus>({ ifNotPresent: 'emptyArray' }),
  states: createEnumArrayParam<PatientState>({ ifNotPresent: 'emptyArray' }),
  lastActivity: DateRangeSettingParam,
  lastVisit: DateRangeSettingParam,
  sqlFilter: StringParam,
};
